/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import MenuContent from 'components/Components/Sections/Menu';
import { Link, NavLink, Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import Guests from 'components/Components/Includes/Guests';
import Popper from 'components/Components/UI/Popper';
import LinkButton from 'components/Components/UI/LinkButton';
import {
    get, isEmpty, isNil, isNull, values,
} from 'lodash';
import Badge from 'components/Components/UI/Badge';
import { connect } from 'react-redux';
import { buildRegionsSelector, getRegions, buildMetaRegionsSelector } from 'store/selectors/regions.selector';
import { getLocalSearchResults } from 'utils/search-helpers';
import { createSelector } from 'reselect';
import { getDestinations } from 'store/selectors/destinations.selector';
import { getHotels } from 'store/selectors/hotels.selector';
import { destinationUrl, hotelUrl } from 'utils/routing-helper';
import { getImgAltText } from 'utils/alt-attribute-helper';
import DatesSelector from 'components/Components/Sections/Header/LoadableDatesSelector';
import DestinationSearch from 'components/Components/Sections/Header/LoadableDestinationSelector';
import QuoteModal from 'components/Components/Sections/Header/LoadableQuoteModal';
import Visibility from 'components/UI/Containers/Visibility';
import clsx from 'clsx';
import { CONSTANTS } from 'services/constants';
import Breadcrumbs from '../BreadCrumbs';
import HeaderTopBar from './HeaderTopBar';

const { SCHEDULE_CALL_LINKS } = CONSTANTS.DATA.BUSINESS_LOGIC;

const getScheduleCallLink = (searchType, searchId) =>
{
    if (searchType !== 'hotel' || !searchId)
    {
        return null;
    }

    return SCHEDULE_CALL_LINKS.DEFAULT;
};

class Header extends React.Component
{
    breadcrumbColor = () =>
    {
        if (typeof window !== 'undefined' && window.scrollY <= 300)
        {
            // if url includes clusters in the url
            if (window.location.href.includes('cluster'))
            {
                return 'tw-text-grey-700';
            }
            return 'tw-text-white';
        }
        return null;
    }

    static getDerivedStateFromProps(props, state)
    {
        if (!props.isSearch && state.isSearch) return { isSearch: false };

        if (props.searchCriteria && !state.isSearch)
        {
            return {
                selectedSearch: props.searchCriteria ? {
                    id: props.searchCriteriaId,
                    name: props.searchCriteria,
                } : null,
                searchCriteria: props.searchCriteria,
                searchType: props.searchCriteriaType,
                searchId: props.searchCriteriaId,
                scheduleCallLink: getScheduleCallLink(props.searchCriteriaType, props.searchCriteriaId),
            };
        }

        return null;
    }

    constructor(props)
    {
        const queryString = typeof window !== 'undefined' ? window.location.search : '';
        const urlParams = new URLSearchParams(queryString);
        const addQuote = urlParams.get('addQuote');
        let hotelLogo = null;
        let headerLink = null;

        // Initialize header logo and header link when getting from the url params
        if (Array.isArray(props.hotels) && props.hotels.length > 0)
        {
            const hotel = props.hotels[0];
            hotelLogo = hotel.logo;
            headerLink = hotelUrl(hotel.destination.region.slug, hotel.destination.parent?.slug, hotel.destination.slug, hotel.slug);
        }

        super(props);
        this.state = {
            showModalQuote: addQuote === 'true',
            logo: 'orange',
            color: 'header-transparent',
            startDate: null,
            endDate: null,
            burgerPosition: 'burger-transparent',
            adults: 2,
            children: 0,
            loadingSearch: true,
            currentWinSize: false,
            errorMessage: '',
            scheduleCallLink: null,
            showSearchBarInput: false,
            redirectUrl: null,
            selectedSearch: null,
            searchCriteria: props.searchCriteria,
            searchType: props.searchCriteriaType,
            isSearch: props.isSearch,
            showControls: false,
            revealed: false,
            datesRevealed: false,
            phoneNumber: '',
            queryString: urlParams.toString(),
            headerLogo: hotelLogo,
            headerUrl: headerLink,
        };

        this.dispatchSearchElements = this.dispatchSearchElements.bind(this);
        this.handleDatesChanged = this.handleDatesChanged.bind(this);
        this.handleFocusChanged = this.handleFocusChanged.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleOpenModalQuote = this.handleOpenModalQuote.bind(this);
        this.handleCloseModalQuote = this.handleCloseModalQuote.bind(this);
        this.handleDateRangeClicked = this.handleDateRangeClicked.bind(this);
        this.handleSearchBarClicked = this.handleSearchBarClicked.bind(this);
        this.listenScrollEvent = this.listenScrollEvent.bind(this);
        this.handleCallAdult = this.handleCallAdult.bind(this);
        this.handleCallChildren = this.handleCallChildren.bind(this);
        this.listenResizeEvent = this.listenResizeEvent.bind(this);
        this.searchElements = this.searchElements.bind(this);
        this.stopRedirection = this.stopRedirection.bind(this);
        this.toggleSearchBar = this.toggleSearchBar.bind(this);
        this._loadDataIfNeeded = this._loadDataIfNeeded.bind(this);

        this.headerRef = React.createRef();
        this.redirecting = false;
        this.searchResolver = {};
        this.headerPhoneNumberRef = React.createRef();
    }

    handleDatesChanged({ startDate, endDate })
    {
        this.setState({
            startDate,
            endDate,
        });
    }

    handleFocusChanged(focusedInput)
    {
        this.setState({ focusedInput });
    }

    handleChange(value)
    {
        let url = null;
        if (value && value.destination_id) // Hotel
        {
            url = hotelUrl(value.destination.region.slug, value.destination.parent?.slug, value.destination.slug, value.slug);
        }
        else if (value && !value.destination_id) url = destinationUrl(value.region.slug, value.parent?.slug, value.slug);

        let headerLogo = null;
        if (value.hasOwnProperty('logo'))
        {
            headerLogo = value.logo;
        }

        this.setState({
            selectedSearch: value,
            searchCriteria: value ? value.name : '',
            searchId: value ? value.id : null,
            scheduleCallLink: getScheduleCallLink(this.state.searchType, value?.id),
            errorMessage: '',
            redirectUrl: url,
            isSearch: true,
            headerLogo,
            headerUrl: url,
        });
    }

    handleCallAdult(a)
    {
        this.setState({
            adults: a,
        });
    }

    handleCallChildren(c)
    {
        this.setState({
            children: c,
        });
    }

    handleOpenModalQuote()
    {
        this.notifyPhoneNumberChanged();
        if (!isEmpty(this.state.searchCriteria))
        {
            this.setState({ showModalQuote: true });
        }
        else
        {
            const error = (
                <div className="xl:tw-container">
                    <div className="tw-flex tw-flex-wrap tw-text-center">
                        <div className="tw-w-full lg:tw-w-1/2 lg:tw-w-1/3 tw-mt-3">
                            <Badge text="Please select an option to quote" className="tw-bg-blue-500" />
                        </div>
                    </div>
                </div>
            );
            this.setState({ errorMessage: error });
        }
    }

    handleCloseModalQuote()
    {
        this.setState({ showModalQuote: false });
    }

    listenResizeEvent()
    {
        this.state.currentWinSize = (window.innerWidth <= 1290);
        if (this.state.currentWinSize)
        {
            this.state.renderNumberOfMonths = 1;
        }
        else
        {
            this.state.renderNumberOfMonths = 2;
        }

        this.clientHeightChanged();
    }

    listenScrollEvent()
    {
        if (this.props.defaultBg === 'header-transparent')
        {
            this.setState({ logo: 'white' });

            if (window.scrollY > 300)
            {
                this.setState({
                    color: 'header-white',
                    logo: 'orange',
                    burgerPosition: 'burger-white',
                });
            }
            else
            {
                this.setState({
                    color: 'header-transparent',
                    logo: 'orange',
                    burgerPosition: 'burger-transparent',
                });
            }
        }
    }

    dispatchSearchElements(searchData, callback)
    {
        return new Promise((resolve) =>
        {
            this.searchResolver = { resolve, callback, criteria: searchData.criteria };
            this.searchElements();
        });
    }

    notifyPhoneNumberChanged = () =>
    {
        const spanText = this.headerPhoneNumberRef.current.textContent;
        this.setState({ phoneNumber: spanText });
    };

    handlePhoneNumberMutation = (mutationsList) =>
    {
        for (const mutation of mutationsList)
        {
            if (mutation.type === 'characterData')
            {
                // Notify the parent when the text content changes
                this.props.onHeaderPhoneNumberTextChange(this.headerPhoneNumberRef.current.textContent);
            }
        }
    };

    componentDidMount()
    {
        window.addEventListener('resize', this.listenResizeEvent);
        window.addEventListener('scroll', this.listenScrollEvent);
        this.clientHeightChanged();

        // Create a Phone Number Mutation Observer
        this.observer = new MutationObserver(this.handlePhoneNumberMutation);

        // Start observing the target node for mutations
        const config = { characterData: true, subtree: true };
        this.observer.observe(this.headerPhoneNumberRef.current, config);
    }

    componentWillUnmount()
    {
        window.removeEventListener('resize', this.listenResizeEvent);
        window.removeEventListener('scroll', this.listenScrollEvent);

        // Stop observing the target node for mutations
        this.observer.disconnect();
    }

    componentDidUpdate()
    {
        if (this.state.redirectUrl && this.redirecting)
        {
            this.stopRedirection();
        }

        if (this.props.metaRegions.loaded)
        {
            this.searchElements();
        }
    }

    _loadDataIfNeeded()
    {
        this.props.onLoadData();
    }

    stopRedirection()
    {
        this.redirecting = false;
        this.setState({ redirectUrl: null });
    }

    toggleSearchBar(e)
    {
        e.preventDefault();
        const { showSearchBarInput } = this.state;
        this.setState({ showSearchBarInput: !showSearchBarInput }, () => this.clientHeightChanged());
    }

    clientHeightChanged()
    {
        if (this.props.onChange)
        {
            this.props.onChange(this.headerRef.current.clientHeight);
        }
    }

    handleSearchBarClicked()
    {
        this.setState({ revealed: true });
        this._loadDataIfNeeded();
    }

    handleDateRangeClicked(type)
    {
        this.setState({ datesRevealed: true, focusedInput: type });
        this._loadDataIfNeeded();
    }

    renderRedirect()
    {
        if (this.state.redirectUrl)
        {
            this.redirecting = true;
            return <Navigate to={this.state.redirectUrl} />;
        }
        return null;
    }

    searchElements()
    {
        const { metaRegions, hotels, destinations } = this.props;

        if (metaRegions.loading || isNil(get(this.searchResolver, 'criteria')))
        {
            return;
        }

        const { criteria, resolve, callback } = this.searchResolver;
        const locations = getLocalSearchResults(hotels, destinations, criteria);

        const options = Object.keys(locations).map((type) =>
        {
            const locationOptions = locations[type].map(location => ({
                ...location,
                section: type,
            }));
            return {
                label: type,
                options: locationOptions,
            };
        });

        callback(options);

        this.searchResolver = {};

        resolve();
    }

    render()
    {
        const {
            showQuoteButton,
            showDatesForm,
            showSearchBar,
            hotels,
            destinations,
            customScheduleCallButton,
        } = this.props;

        const {
            loadingSearch,
            errorMessage,
            revealed,
            datesRevealed,
            queryString,
            scheduleCallLink,
            selectedSearch,
        } = this.state;

        const pathname = typeof window !== 'undefined' ? window.location.pathname : '';
        const breadCrumbCondition = pathname.includes('hotels') || pathname.includes('destinations');
        const hideSearchEngine = pathname.includes('get-quote/thank-you');
        const barPadding = breadCrumbCondition ? 'tw-py-0' : 'tw-py-4';

        const renderGuestsInput = (
            <span className="tw-cursor-pointer">
                <label className="tw-text-white tw-uppercase font-sp">Guests</label>
                <div
                    className="tw-text-white tw-my-1"
                >{`${this.state.adults} Adults, ${this.state.children} Children`}</div>
            </span>
        );

        const renderGuestsContent = (
            <Guests
                deafultAdults={this.state.adults}
                deafultChildren={this.state.children}
                parentCallAdult={this.handleCallAdult}
                parentCallChildren={this.handleCallChildren}
            />
        );

        const scheduleCallButton = customScheduleCallButton || (
            <Popper
                onHover
                bgColor="tw-bg-white !tw-h-auto !tw-p-2 !tw-text-center tw-hidden md:tw-hidden lg:tw-block xl:tw-hidden"
                minWidth={180}
                placement="bottom-end"
                reference={(
                    <LinkButton
                        text={(
                            <>
                                <svg className="tw-hidden md:tw-hidden lg:tw-block xl:tw-hidden" xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" shapeRendering="geometricPrecision" textRendering="geometricPrecision" imageRendering="optimizeQuality" fillRule="evenodd" clipRule="evenodd" viewBox="0 0 508 511.92">
                                    <g>
                                        <path fill="white" fillRule="nonzero" d="M79.46 44.6l40.89 0 0 54.55c0,15.17 7.05,28.57 18.43,37.89 9.62,7.89 22.42,12.77 36.09,12.77 13.67,0 26.47,-4.88 36.09,-12.77 11.38,-9.32 18.44,-22.72 18.44,-37.89l0 -54.55 82.54 0 0 54.55c0,15.17 7.06,28.57 18.44,37.89 9.62,7.89 22.41,12.77 36.09,12.77 13.67,0 26.47,-4.88 36.09,-12.77 11.38,-9.32 18.43,-22.72 18.43,-37.89l0 -54.55 42.68 0c24.39,0 44.33,19.94 44.33,44.33l0 102.93 0 262.55c0,12.2 -4.99,23.28 -13.02,31.31 -8.06,8.03 -19.14,13.02 -31.31,13.02l-203.51 0c2.39,-4.64 4.43,-9.61 5.91,-14.66 0.42,-1.42 0.8,-2.84 1.14,-4.27l182.26 0c19.18,0 34.87,-15.75 34.87,-34.86l0 -272.02 -425.54 0 0 71.75c-8.48,-0.64 -16.37,-0.22 -23.66,1.08l0 -53.9 0 -102.94c0,-24.34 19.98,-44.32 44.32,-44.32zm282.17 308.91l58.08 0c4.07,0 7.4,3.35 7.4,7.4l0 48.31c0,4.05 -3.35,7.4 -7.4,7.4l-58.08 0c-4.05,0 -7.4,-3.33 -7.4,-7.4l0 -48.31c0,-4.07 3.33,-7.4 7.4,-7.4zm-238.2 -125.6l58.07 0c4.07,0 7.4,3.35 7.4,7.4l0 48.31c0,4.05 -3.35,7.4 -7.4,7.4l-58.07 0c-4.05,0 -7.4,-3.33 -7.4,-7.4l0 -48.31c0,-4.07 3.33,-7.4 7.4,-7.4zm238.2 0l58.08 0c4.06,0 7.4,3.35 7.4,7.4l0 48.31c0,4.05 -3.35,7.4 -7.4,7.4l-58.08 0c-4.05,0 -7.4,-3.33 -7.4,-7.4l0 -48.31c0,-4.07 3.33,-7.4 7.4,-7.4zm-115.96 0l58.07 0c4.07,0 7.4,3.35 7.4,7.4l0 48.31c0,4.05 -3.35,7.4 -7.4,7.4l-58.07 0c-4.05,0 -7.4,-3.33 -7.4,-7.4l0 -48.31c0,-4.07 3.33,-7.4 7.4,-7.4zm0 125.6l58.07 0c4.07,0 7.4,3.35 7.4,7.4l0 48.31c0,4.05 -3.35,7.4 -7.4,7.4l-58.07 0c-4.05,0 -7.4,-3.33 -7.4,-7.4l0 -48.31c0,-4.07 3.33,-7.4 7.4,-7.4zm-177.2 25.49c7.21,12.32 15.48,24.15 25.85,35.07 11.94,12.65 26.8,24.17 46.06,33.98 1.43,0.71 2.78,0.71 3.98,0.21 4.14,-1.59 8.01,-6.76 10.59,-10.24 7.4,-9.74 16.57,-21.82 29.51,-15.78 0.28,0.14 0.5,0.29 0.78,0.43l43.15 24.81c0.14,0.07 0.28,0.21 0.42,0.28 5.69,3.92 8.04,9.96 8.11,16.78 0,6.97 -2.56,14.79 -6.33,21.4 -15.23,26.77 -58.6,30.3 -85.44,22.03 -18.41,-5.68 -44.06,-20.73 -60.36,-32.91 -24.81,-18.7 -50.04,-45.71 -66.46,-75.42 -13.8,-24.95 -21.33,-51.89 -17.2,-77.56 2.27,-14.07 8.31,-26.87 18.83,-35.33 9.17,-7.39 21.54,-11.44 37.54,-10.02 1.85,0.14 3.48,1.21 4.33,2.77l27.66 46.78c4.05,5.26 4.54,10.45 2.34,15.63 -1.85,4.27 -5.54,8.18 -10.59,11.88 -4.98,4.27 -17.15,10.68 -16.36,17.97 0.26,2.28 2.32,5.07 3.59,7.24zm276.59 -361.45c0,-9.68 9.58,-17.55 21.41,-17.55 11.83,0 21.4,7.87 21.4,17.55l0 81.6c0,9.68 -9.57,17.55 -21.4,17.55 -11.83,0 -21.41,-7.87 -21.41,-17.55l0 -81.6zm-191.59 0c0,-9.68 9.57,-17.55 21.4,-17.55 11.83,0 21.41,7.87 21.41,17.55l0 81.6c0,9.68 -9.58,17.55 -21.41,17.55 -11.83,0 -21.4,-7.87 -21.4,-17.55l0 -81.6z" />
                                    </g>
                                </svg>
                                <span className="md:tw-block lg:tw-hidden xl:tw-block">
                                    SCHEDULE A CALL
                                </span>
                            </>
                        )}
                        alt="SCHEDULE A CALL"
                        tab="_blank"
                        link={`${scheduleCallLink}?${queryString}`}
                        className="btn-orange tw-bg-orange-400 tw-w-full tw-h-full tw-text-white tw-flex tw-items-center tw-justify-center tw-pl-2 tw-pr-2"
                    />
                )}
                content={<>SCHEDULE A CALL</>}
            />
        );

        return (
            <>

                {/* Search redirect */}
                {this.renderRedirect()}

                {/* Full Menu */}
                <MenuContent
                    className={`${this.props.defaultBurgerPosition} ${this.state.burgerPosition} ${this.state.color === 'header-transparent' ? 'tw-mt-10' : ''}`}
                    customBurgerIcon={false}
                />

                {/* Anchor Span */}
                <span id="top" />
                {/* Mini Menu and Search Engine */}
                <>
                    {/* Header Top Bar */}
                    <HeaderTopBar
                        content={(
                            <>
                                Earn More With Our Rewards Program: <a className="tw-underline" href="https://landing.luxuriavacations.com/rewards" target="_blank">
                                    <span>Learn More</span>
                                </a>
                            </>
                        )}
                    />
                    {/* Header Top Bar */}

                    <nav className={`header ${this.state.color} ${this.props.defaultBg} ${this.state.color === 'header-transparent' ? 'tw-mt-10' : ''}`}>
                        <div className={`tw-w-full tw-text-center tw-px-4 ${barPadding}`} ref={this.headerRef}>

                            {/* Mini Menu */}
                            <div className="tw-flex tw-justify-between">
                                <div className="tw-w-1/2 tw-m-2 tw-flex tw-items-center">
                                    <div className="tw-flex tw-flex-wrap tw-justify-between tw-w-full">
                                        <div className="tw-w-auto" />
                                        <div className="tw-w-auto">
                                            <NavLink
                                                to="/hotels"
                                                className="nav-menu-item tw-uppercase font-sp tw-mr-4 tw-hidden xl:tw-inline"
                                            >Hotels</NavLink>
                                            <span
                                                className="tw-rounded-full tw-h-1 tw-w-1 tw-bg-gray-700 tw-inline-block tw-align-middle tw-hidden xl:tw-inline-block"
                                            />
                                            <NavLink
                                                to="/destinations"
                                                className="nav-menu-item tw-uppercase font-sp tw-mx-4 tw-hidden xl:tw-inline"
                                            >Destinations</NavLink>
                                        </div>
                                    </div>
                                </div>
                                <div className="tw-w-64 tw-text-center tw-my-2 tw-mx-2">
                                    <Link to="/">
                                        <picture className="tw-hidden xl:tw-inline-block md:tw-block  sm:tw-hidden">
                                            <img
                                                width="150"
                                                height={40.03}
                                                className="tw-m-auto"
                                                src={`/assets/brand/luxuria-vacations-logo-${this.state.logo}.svg`}
                                                alt={getImgAltText('Luxuria Vacations')}
                                            />
                                        </picture>

                                        {/* mobile */}
                                        <picture className=" sm:tw-block xl:tw-hidden md:tw-hidden">
                                            <img
                                                loading="lazy"
                                                width="30"
                                                height={33.875}
                                                className="tw-m-auto"
                                                src="/assets/brand/luxuria-vacations-logo-mobile.svg"
                                                alt={getImgAltText('Luxuria Vacations')}
                                            />
                                        </picture>
                                    </Link>
                                </div>


                                <div className="tw-w-1/2 tw-text-gray-700 tw-m-2 tw-flex tw-items-center">
                                    <div className="tw-flex tw-flex-wrap tw-justify-between tw-w-full">
                                        <div className="tw-w-auto">

                                            <a href="https://landing.luxuriavacations.com/about-us" className="nav-menu-item tw-uppercase font-sp tw-mr-4 tw-hidden xl:tw-inline"> About Us </a>

                                            <span
                                                className="tw-rounded-full tw-h-1 tw-w-1 tw-bg-gray-700 tw-inline-block tw-align-middle tw-hidden xl:tw-inline-block"
                                            />

                                            <a href="https://blog.luxuriavacations.com/blog" target="_blank" className="nav-menu-item tw-uppercase font-sp tw-mr-4 tw-hidden xl:tw-inline"> Blog </a>

                                        </div>

                                        <div className="tw-w-auto">
                                        </div>
                                        <div className="tw-w-auto">
                                            {
                                                !showSearchBar
                                                    ? (
                                                        <a
                                                            href="#"
                                                            onClick={this.toggleSearchBar}
                                                            className={`nav-menu-item tw-inline ${!showSearchBar ? 'tw-block lg:tw-hidden' : ''}`}
                                                        >
                                                            <span className="material-icons tw-align-middle">search</span>
                                                        </a>
                                                    )
                                                    : null
                                            }

                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Search Engine */}
                            <div className={`tw-w-100 tw-bg-gray-900 tw-bg-opacity-75 ${hideSearchEngine ? 'tw-hidden' : ''}`}>
                                <div
                                    className={clsx({
                                        'tw-mx-auto tw-text-left': true,
                                        'xl:tw-max-w-[1280px]': isNull(scheduleCallLink),
                                        'xl:tw-max-w-[1500px]': !isNull(scheduleCallLink),
                                    })}
                                >
                                    <div className="tw-flex tw-flex-wrap">

                                        <div
                                            className={`tw-w-full lg:tw-w-1/4 tw-border-solid tw-border-b lg:tw-border-b-0 xl:tw-border-l tw-border-white tw-border-opacity-25 tw-py-2 tw-px-4 ${(!showSearchBar && !this.state.showSearchBarInput) ? 'tw-hidden lg:tw-block' : ''}`}
                                        >
                                            {!revealed && (
                                                <>
                                                    <p className="tw-mt-1 tw-text-white tw-uppercase font-sp">
                                                        Where are you going?<br />
                                                    </p>
                                                    <p className="tw-text-white tw-mt-1 tw-mb-0" onClick={() => this.handleSearchBarClicked()}>
                                                        {get(selectedSearch, 'name', 'Select...')}
                                                    </p>
                                                </>

                                            )}

                                            {revealed && (
                                                <DestinationSearch
                                                    handleChange={this.handleChange}
                                                    hotels={hotels}
                                                    destinations={destinations}
                                                    selectedSearch={selectedSearch}
                                                    getOptionValue={this._getOptionValue}
                                                    getOptionLabel={this._getOptionLabel}
                                                    search={this.dispatchSearchElements}
                                                    loading={loadingSearch}
                                                />
                                            )}
                                        </div>


                                        <div
                                            className={clsx({
                                                'tw-w-full sm:tw-w-1/2 lg:tw-w-1/4 tw-border-solid tw-border-b sm:tw-border-b-0 lg:tw-border-l tw-border-white tw-border-opacity-25 tw-py-2 tw-px-4 tw-hidden lg:tw-block': true,
                                                '!tw-invisible': !showDatesForm,
                                            })}
                                        >
                                            <label className="tw-text-white tw-uppercase font-sp">Dates</label>
                                            <div className="tw-my-1">
                                                <div className="datepicker-wrap tw-relative">
                                                    {!datesRevealed && (
                                                        <>
                                                            <div className="tw-text-white tw-mt-1 tw-mb-0">
                                                                <div style={{ width: '49%', display: 'inline-block' }} className="tw-inline-block" onClick={() => this.handleDateRangeClicked('startDate')}>
                                                                    Check In
                                                                </div>
                                                                <div style={{ color: 'white !important', fontWeight: 300 }} className="tw-inline-block" aria-hidden="true" role="presentation">|
                                                                </div>
                                                                <div style={{ width: '49%', paddingLeft: 15 }} className="tw-inline-block" onClick={() => this.handleDateRangeClicked('endDate')}>
                                                                    Check Out
                                                                </div>
                                                            </div>
                                                        </>

                                                    )}
                                                    {datesRevealed && (
                                                        <DatesSelector
                                                            startDate={this.state.startDate}
                                                            endDate={this.state.endDate}
                                                            onDatesChange={this.handleDatesChanged}
                                                            onFocusChange={this.handleFocusChanged}
                                                            focusedInput={this.state.focusedInput}
                                                            renderNumberOfMonths={this.state.renderNumberOfMonths}
                                                        />
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            className={clsx({
                                                'tw-w-full sm:tw-w-1/2 lg:tw-w-1/6 tw-border-solid sm:tw-border-l tw-border-white tw-border-opacity-25 tw-py-2 tw-px-4 tw-hidden lg:tw-block': true,
                                                '!tw-invisible': !showDatesForm,
                                            })}
                                        >
                                            {(revealed || selectedSearch) && (
                                                <Popper
                                                    content={renderGuestsContent}
                                                    reference={renderGuestsInput}
                                                    bgColor="tw-bg-white"
                                                />
                                            )}

                                        </div>

                                        {showQuoteButton && (
                                            <div className="tw-w-1 tw-flex-grow header-quote-btn-cont">
                                                <LinkButton
                                                    text="Quote Your Trip"
                                                    link="#"
                                                    className="btn-orange tw-bg-orange-400 tw-w-full tw-h-full tw-text-white tw-pl-2 tw-pr-2 tw-flex tw-items-center tw-justify-center"
                                                    onClick={this.handleOpenModalQuote}
                                                />
                                            </div>
                                        )}

                                        <div
                                            className={clsx({
                                                'tw-w-full sm:tw-w-1/2 tw-border-solid sm:tw-border-l tw-border-white tw-border-opacity-25 tw-py-2 tw-px-2 lg:tw-block': true,
                                                'lg:tw-w-1/5': isNull(scheduleCallLink),
                                                'lg:tw-w-fit': !isNull(scheduleCallLink),
                                            })}
                                        >
                                            <a href="tel:18447858575" className="tw-flex tw-items-center tw-justify-center tw-w-fit tw-uppercase font-sp tw-py-4 tw-mx-auto tw-inline-block undefined tw-w-full tw-h-full tw-text-white tw-pt-4 tw-pb-3">
                                                <span id="headerPhoneNumber" ref={this.headerPhoneNumberRef} className="font-sp  xl:tw-inline">1 (844) 785-8575</span>
                                                <span
                                                    className="material-icons tw-align-middle rotate-270"
                                                >phone</span>
                                            </a>
                                        </div>

                                        { !isNull(scheduleCallLink) && (
                                            <div className="tw-w-1 tw-flex-grow header-quote-btn-cont">
                                                {scheduleCallButton}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* Error in Search Engine */}
                            {
                                errorMessage
                            }
                            <Visibility show={breadCrumbCondition}>
                                <Breadcrumbs textColor={this.breadcrumbColor()} />
                            </Visibility>
                        </div>
                    </nav>
                </>

                {/* Modal Quote */}
                {this.state.showModalQuote && (
                    <QuoteModal
                        show={this.state.showModalQuote}
                        onClose={this.handleCloseModalQuote}
                        searchCriteria={this.state.searchCriteria}
                        searchType={this.state.searchType}
                        searchId={this.state.searchId}
                        startDate={this.state.startDate}
                        endDate={this.state.endDate}
                        adults={this.state.adults}
                        childs={this.state.children}
                        headerPhoneNumber={this.state.phoneNumber}
                        headerLogo={this.state.headerLogo}
                        headerUrl={this.state.headerUrl}
                    />
                )}
            </>
        );
    }

    _getOptionLabel(option)
    {
        return option ? `${get(option, 'name', '')}` : '';
    }

    _getOptionValue(option)
    {
        return option ? option.id || null : null;
    }
}

Header.defaultProps = {
    searchCriteria: null,
    searchCriteriaType: null,
    showSearchBar: true,
    showQuoteButton: true,
    showDatesForm: true,
    defaultBg: 'header-transparent',
    defaultBurgerPosition: 'burger-transparent',
    isSearch: false,
};

Header.propTypes = {
    defaultBg: PropTypes.string,
    defaultBurgerPosition: PropTypes.string,
    destinations: PropTypes.array,
    hotels: PropTypes.array,
    metaRegions: PropTypes.object,
    onChange: PropTypes.func,
    onLoadData: PropTypes.func,
    searchCriteria: PropTypes.string,
    searchCriteriaType: PropTypes.string,
    showSearchBar: PropTypes.bool,
    showQuoteButton: PropTypes.bool,
    showDatesForm: PropTypes.bool,
    isSearch: PropTypes.bool,
    onHeaderPhoneNumberTextChange: PropTypes.func,
    customScheduleCallButton: PropTypes.element,
};

const mapStateToProps = () =>
{
    const regionsSelector = buildRegionsSelector();
    const metaRegionsSelector = buildMetaRegionsSelector();
    const destinationsSelector = createSelector([getDestinations, getRegions], (destinations, regions) => values(destinations).map(destination => ({
        ...destination,
        region: { ...regions[destination.region_id] },
    })));
    const hotelsSelector = createSelector([getHotels, getDestinations, getRegions], (hotels, destinations, regions) => values(hotels).map((hotel) =>
    {
        const destination = destinations[hotel.destination_id];
        const region = regions[destination.region_id];

        return {
            ...hotel,
            destination: { ...destination, region: { ...region } },
        };
    }));

    return state => ({
        destinations: destinationsSelector(state),
        hotels: hotelsSelector(state),
        regions: regionsSelector(state),
        metaRegions: metaRegionsSelector(state),
    });
};

const mapDispatchToProps = () => ({});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Header);
